(function ( $ ) {
    $.fn.scrollTo = function() {
        var that = this;
        return this.click(function(e) {
            var target = $(this).data('scroll-to'),
                timing = $(this).data('timing') || 800,
                bezier = [0.645, 0.045, 0.355, 1.000];

            // console.log(target);
                
            e.preventDefault();

            if ($(target).length) {
                // $("html, body").animate(
                //     {
                //         scrollTop: $(target).offset().top,
                //     }, 
                //     timing, 
                //     $.bez(bezier)
                // );
                $(target).velocity("scroll", { duration: timing, easing: [0.645, 0.045, 0.355, 1.000] });
            };
        });
    };
}( jQuery ));

$(function() {
    if ($('.js-scroll-to').length) {
        $('.js-scroll-to').scrollTo();
    }
});

// function stickCol(){
//     var $that = $('.js-to-stuck'),
//         $parent = $that.parent(),
//         offset = $parent.offset().top,
//         h = $that.height() + offset;

//     if ((wt + h > ft - 80)&&(wt > 0)) {
//         $('.js-to-stuck').addClass('stuck-footer');
//     } else {
//         $('.js-to-stuck').removeClass('stuck-footer');
//     }
// };











